(() => {
  'use strict';

  function isMetaInAppBrowser() {
    const ua = navigator.userAgent || navigator.vendor || '';
    return /FBAN|FBAV|FBIOS|FB_IAB|Instagram/i.test(ua);
  }

  function showBanner() {
    if (!isMetaInAppBrowser() || document.querySelector('[data-salty-inapp-banner]')) return;

    const banner = document.createElement('div');
    banner.setAttribute('data-salty-inapp-banner', 'true');
    banner.setAttribute('role', 'status');
    banner.innerHTML = '<span>For a better browsing experience, open our website in your preferred web browser or click the 3 dots on the top right of the page and click open in external browser. This will solve any checkout issues that may be experienced.</span><button type="button" aria-label="Dismiss checkout tip">×</button>';

    Object.assign(banner.style, {
      position: 'fixed',
      left: '10px',
      right: '10px',
      bottom: '10px',
      zIndex: '2147483647',
      display: 'flex',
      gap: '10px',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '12px 14px',
      borderRadius: '14px',
      background: '#EF1395',
      color: '#ffffff',
      fontSize: '14px',
      lineHeight: '1.35',
      boxShadow: '0 8px 24px rgba(0,0,0,.18)'
    });

    const button = banner.querySelector('button');
    Object.assign(button.style, {
      appearance: 'none',
      border: '0',
      background: 'rgba(255,255,255,.18)',
      color: '#ffffff',
      borderRadius: '999px',
      width: '28px',
      height: '28px',
      fontSize: '20px',
      lineHeight: '28px',
      cursor: 'pointer',
      flex: '0 0 auto'
    });
    button.addEventListener('click', () => banner.remove());

    document.body.appendChild(banner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showBanner);
  } else {
    showBanner();
  }
})();
